import IndexHeader from "app/shared-components/IndexHeader";
import React, { useEffect, useState } from "react";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import ProgramDetailsDialog from "./program-detail-popup";
import { EnrolledProgram, YouthRequest } from "src/app/interfaces/my.youth";
import { myYouthService } from "src/app/services/api/my-youth.service";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#202441",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const MyYouthList = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [youthRequests, setYouthRequests] = useState<YouthRequest[]>([]);
  const [enrolledPrograms, setEnrolledPrograms] = useState<EnrolledProgram[]>(
    []
  );

  useEffect(() => {
    fetchYouthRequests();
    fetchEnrolledPrograms();
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const fetchYouthRequests = (): void => {
    myYouthService
      .getYouthRequests()
      .then((res) => setYouthRequests(res.data.requests))
      .catch((err) =>
        console.error("Failed to load youth requests", err.message)
      );
  };

  const fetchEnrolledPrograms = (): void => {
    myYouthService
      .getEnrolledPrograms()
      .then((res) => setEnrolledPrograms(res.data.programs))
      .catch((err) =>
        console.error("Failed to load enrolled programs", err.message)
      );
  };

  return (
    <>
      <IndexHeader name={"My Youth"} update={false} add={false} />
      <div className="m-24">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>First Name</StyledTableCell>
                <StyledTableCell>Last Name</StyledTableCell>
                <StyledTableCell>Requested Date</StyledTableCell>
                <StyledTableCell>Enrolled Programs</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {youthRequests.map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell>{row.firstName}</StyledTableCell>
                  <StyledTableCell>{row.lastName}</StyledTableCell>
                  <StyledTableCell>{row.requestedDate}</StyledTableCell>
                  <StyledTableCell>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => setShowPopup(true)}
                    >
                      View
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <ProgramDetailsDialog
        open={showPopup}
        onClose={handleClosePopup}
        data={enrolledPrograms}
      />
      ;
    </>
  );
};

export default MyYouthList;
